export const formatNumberCurrency = (number: number) => {
  if (!number) return 'Rp0';
  return number
    .toLocaleString('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 20,
    })
    .replace(/\u00A0/g, '');
};

export const formatNumberCurrencyWithoutRP = (number: number) => {
  return number
    .toLocaleString('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 20,
    })
    .replace('Rp', '')
    .trim();
};
